export const getCookie = () => {
  if (typeof document === 'undefined' || !document.cookie) {
    return {};
  }

  let allCookies = document.cookie.split(';');
  let result = {};
  for (var i = 0; i < allCookies.length; i++) {
    let cookie = allCookies[i].split('=');
    let rawName = cookie[0] ? cookie[0].trim() : '';
    if (!rawName) {
      continue;
    }

    try {
      let cookieName = decodeURIComponent(rawName);
      let cookieValue = cookie[1] != null ? decodeURIComponent(cookie[1].trim()) : '';
      result[cookieName] = cookieValue;
    } catch (e) {
      // skip malformed cookie entries instead of crashing the page
    }
  }
  return result;
}

export const refreshSessionData = async () => {
  const phpApi = process.env.phpApiUrl;
  const res = await fetch(`${phpApi}/reload_session.php`);
  //console.log('session data=', res.status);

  if (res.status == 200) {
    return true;
  }

  return false;
}